<template>
  <v-row justify="center">
    <v-dialog v-model="openPopup" persistent max-width="290">
      <v-card>
        <v-card-text class="card-text-styling">
          Are you sure you want to cancel this records request?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="action-btn-styling">
          <v-btn color="green darken-1" text @click="$emit('leftBtnClick')">
            {{ leftBtnLabel }}
          </v-btn>
          <v-btn color="green darken-1" text @click="$emit('rightBtnClick')">
            {{ rightBtnLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    openPopup: {
      type: Boolean,
      default: false
    },
    leftBtnLabel: {
      type: String,
      default: ''
    },
    rightBtnLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.card-text-styling {
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 16px !important;
  text-align: center !important;
}

.action-btn-styling {
  display: flex;
  justify-content: flex-end;
}

.action-btn-styling .v-btn__content {
  color: #1A73EB !important;
  font-weight: 600 !important;
}
</style>
